import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { UserService } from './services';
import { AppSettingsService } from './services/app-settings.service';


@Component({
    selector: "app-footer",
    templateUrl: "./app-footer.component.html",
    styleUrls: ["./app-footer.component.less"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink]
})
export class AppFooterComponent {
  private readonly _componentName = 'AppFooterComponent';

  storeUrl: string;
  giftShopUrl: string;

  private _copyrightYear: string;

  constructor(readonly router: Router, readonly appSettings: AppSettingsService, readonly changeDetector: ChangeDetectorRef, private userService:UserService) {
    this.copyrightYear = new Date().getFullYear().toString();

    // this.appSettings.load().subscribe(settings => {
    //   // Setup the store urls

    //   this.storeUrl = `${settings.storeUrl}`;

    //   this.giftShopUrl = `${settings.storeUrl}/gift-shop`;

    //   this.changeDetector.markForCheck();
    // });
  }
  settings = {};
  get showFooter() {
    return this.router.url !== '/search';
  }

  /**
   * Gets the copyright Year to use in the Copyright Text
   */
  public get copyrightYear(): string {
    return this._copyrightYear;
  }

  
  
  public get isAdmin() : boolean {
    return this.userService.isAdmin;
  }
  

  /**
   * Sets the copyright Year to use in the Copyright Text
   */
  public set copyrightYear(v: string) {
    this._copyrightYear = v;
  }
}
